import moment from 'moment';

export const formatedDate = (date) => {
	return moment.unix(date).format('DD/MM/YYYY hh:mm:ssa');
};
